module.exports = __webpack_public_path__ + "static/bottom-95af20bdf0df3fbf8f1f1bc549b72b05.png";